import React, { Component } from "react";
import {withNamespaces} from "react-i18next";
import {connect} from "react-redux";
import BreadcrumbExtend from "../../../../components/BreadcrumbExtend";
import {networkDeviceActions} from "../../../../actions/network-device.actions";
import {Link} from "react-router-dom";
import {Button} from "react-bootstrap";
import {modalActions} from "../../../../actions/modal.actions";
import DmxPxmSceneTable from "./_components/DmxPxmSceneTable";
import {pxmModbusActions} from "../../../../actions/pxm-modbus.actions";
import DmxDeviceInfo from "../_components/DmxDeviceInfo";
import DmxPxmSceneForm from "./_forms/DmxPxmSceneForm";

class DmxPxmScenePage extends Component {
    networkDeviceId = null;

    componentDidMount() {
        const { id }  = this.props.match.params;
        const { dispatch } = this.props;

        this.networkDeviceId = parseInt(id);

        dispatch(pxmModbusActions.getSceneList(this.networkDeviceId));
        dispatch(networkDeviceActions.getNetworkDeviceSimpleInfo(this.networkDeviceId));
    }

    openModalCreatePxmScene = (e) => {
        e.preventDefault();
        const { t, dispatch } = this.props;
        const { id }  = this.props.match.params;
        const modalProps = {
            open: true,
            title: t('add-dmx-scene'),
            component: <DmxPxmSceneForm networkDeviceId={id} submitForm={this.handleSubmitCreatePxmScene}/>
        };
        dispatch(modalActions.showModal({modalProps: modalProps, modalType: 'formModal'}))
    };

    handleSubmitCreatePxmScene = (model) => {
        const { dispatch } = this.props;
        delete model.id;
        dispatch(pxmModbusActions.createScene(model));
    };

    render() {
        const { t, simpleDeviceInfo, pxmModbusScenes, pxmModbusCurrentScene } = this.props;

        const breadcrumb = [
            { value: 'network-device', path: '/panel/network-device' },
            { value: `${simpleDeviceInfo?.label} - ${t('dmx-scene')}`, path: "#" },
        ];

        return(
            <div>
                <BreadcrumbExtend items={breadcrumb}/>
                <DmxDeviceInfo networkDeviceInfo={simpleDeviceInfo} title={'dali-scene'}/>

                <div className="card">
                    <div className="card-header">
                        <div className="button-group float-right">
                            <Button variant={"success"} onClick={this.openModalCreatePxmScene}>
                                <i className="fas fa-plus"/> {t('add-scene')}
                            </Button>
                            &nbsp;
                            <Link to={`/panel/network-device/`} className="btn btn-secondary">
                                <i className="fas fa-undo"> </i> {t('back-to-list')}
                            </Link> &nbsp;
                        </div>
                    </div>
                    <div className="card-body">
                        <DmxPxmSceneTable list={pxmModbusScenes} />
                    </div>
                </div>

            </div>
        )
    }
}
const mapStateToProps = (state) => {
    const { simpleDeviceInfo} = state.networkDeviceReducer;
    const { pxmModbusScenes, pxmModbusCurrentScene } = state.pxmModbusReducer;
    return {
        pxmModbusScenes,
        pxmModbusCurrentScene,
        simpleDeviceInfo,
    }
};
export default withNamespaces()(connect(mapStateToProps)(DmxPxmScenePage));
